module.exports = __webpack_public_path__ + "static/media/wizualizacja-64.f528e24a.png";